import instance from "../../../config/axios";
import url from "../../../constants/url";

const auditReports = "audit-reports";
const grid = "grid-list";
const viewPickList = "view-pick-list";

export const getViewPickList = async() => {
  return instance
    .get(`${url.packagingapiurl}${auditReports}/${viewPickList}`)
    .then((res) => {
      return res;
    });
};

export const getAuditReportsListApi = async (payload) => {
  return instance
    .post(`${url.packagingapiurl}${auditReports}/${grid}`, payload)
    .then((res) => {
      return res;
    });
}